import s from "universal-cookie";
import { testTypes as n } from "./data/aitests.js";
const a = () => {
  const e = Math.floor(Math.random() * 10);
  return {
    0: "positive",
    1: "negative"
  }[e / e || 0];
}, u = (e) => {
  new s().set("minohealth_user", e, {
    path: "/",
    sameSite: !0,
    maxAge: 3600 * 3
  });
}, h = () => new s().get("minohealth_user"), m = () => new s().remove("minohealth_user"), k = (e) => {
  const o = /* @__PURE__ */ new Date();
  new s().set(
    `minohealth_user_two_factor_verified-${e}`,
    `${o.getFullYear()}:${o.getMonth()}:${o.getDay()}`
  );
}, _ = (e) => {
  const o = /* @__PURE__ */ new Date();
  return new s().get(`minohealth_user_two_factor_verified-${e}`) === `${o.getFullYear()}:${o.getMonth()}:${o.getDay()}`;
}, l = (e) => Object.values(e).reduce((o, t) => t === n.SAMPLE_CHEST_XRAY_PRE_SCANNING ? o : [
  ...o,
  {
    name: t,
    value: t
  }
], []);
export {
  h as getFreshCookie,
  l as getTestOptions,
  _ as isTwoFactorVerifiedToday,
  a as randomizeStatus,
  m as removeCookie,
  u as setFreshCookie,
  k as setVerified2FactorTodayCookie
};
